import axios from 'axios'
import { User } from "oidc-client-ts"


const httpClient = axios.create({
    baseURL: '',
    timeout: 120000, // default timeout set to 2 mins
});

function getUser() {
    const authority = process.env.REACT_APP_COGNITO_AWS_AUTHORITY
    const client_id = process.env.REACT_APP_COGNITO_AWS_CLIENT_ID
    const oidcStorage = sessionStorage.getItem(`oidc.user:${authority}:${client_id}`)
    if (!oidcStorage) {
        return null;
    }
    return User.fromStorageString(oidcStorage);
}

const useAuthIntercepter = async (config) => {
    const user = getUser();
    const idToken = user?.id_token;

    if (isValidToken(idToken)) {
        config.headers['Authorization'] = idToken
    } else {
        // TODO: Get refreshed token and pass it
    }
    return config
}


const isValidToken = (token) => {
    if (!token) {
        return false
    }
    // TODO: Implement expiry time validation
    return true
}

httpClient.interceptors.request.use(useAuthIntercepter)

export default httpClient;